import React,{useState} from 'react'
import {TextField, Button, Box, Checkbox, Typography, FormControlLabel} from '@material-ui/core';
import { makeStyles, useTheme} from '@material-ui/core/styles';
import { Alert} from '@material-ui/lab';
import * as firebase from 'firebase';

import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme)=>({
    input:{
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      width: '100%'
    },
    button:{
        color:'white',
        fontFamily: 'ShameimaruSans',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        width: '100%'
    },
    buttonSecondary:{
        color: theme.palette.text.secondary,
       
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
     
    },
    box:{
        display:'flex',
        justifyContent:'center'
    },
    successContainer:{
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent:'center'
    },
  }));



export default function AdditionalForm(props) {
const [favorite, setFavorite] = useState()
const [hasAnswered, setHasAnswered] = useState(false)
const [email, setEmail] = useState('')
const classes = useStyles()
let analytics= firebase.analytics()
let db = firebase.firestore()
const [checked, setChecked] = useState(false)
const { register, handleSubmit , errors, setValue } = useForm();
const theme = useTheme()
const [error, setError] = useState()

const handleButtonClick=()=> {
  // if(checked){
    if(email!==''){
      analytics.logEvent('feedback_second_step_email', {answer: `${props.answerMap[props.answer]}`})
    }
    if(props.top){
      analytics.logEvent('feedback_second_step_submit', {answer: `${props.answerMap[props.answer]}`})
        db.collection('answers').add({
            type:'tankstelle',
            answer: favorite,
            email: email,
            time: new Date()
          }).then(()=>{
            
            setHasAnswered(true)
          })       
    }else{
      analytics.logEvent('feedback', {answer: `${props.answerMap[props.answer]}-email`})
        db.collection('answers').add({
            type:'tankstelle',
            answer: favorite,
            email: email,
            time: new Date()
          }).then(()=>{
            
            setHasAnswered(true)
            
          })
        
    }
  // }else{
  //   setError(true)
  // }
}

console.log({answer:hasAnswered})

const handleBack= ()=>{
    props.setStation()
    props.changePage(1)

}

const handleCheck = ()=>{
  setError()
  setChecked(!checked)
}


    return (
        <React.Fragment>
        {hasAnswered?
            <Box className={classes.successContainer}>
                <Alert variant='filled' severity='success'  align='center' >
                Vielen Dank für dein Feedback. Wir arbeiten hart daran, unser Angebot zu verbessern.
                </Alert>
                <Button onClick={()=>handleBack()} variant='text' className={classes.buttonSecondary}  >Zurück</Button>
            </Box>:
        <form onSubmit={()=>handleButtonClick()}>
        <TextField
        className={classes.input}
          onChange={(event)=>setFavorite(event.target.value)}
          label="PLZ"
          color='secondary'
          type='number'
          required
          fullWidth
          variant='outlined'
          helperText='Hilf uns mit deinem PLZ-Wunsch, damit wir den Service weiter ausbauen können.'
        />
        {/* <TextField
          onChange={(event)=>setEmail(event.target.value)}
          label="Email"
          color='secondary'
            type='email'
          fullWidth
          variant='outlined'
          helperText='Optional: Wir schicken dir gerne eine E-Mail wenn eine Tankstelle in deiner Nähe verfügbar ist'
        />
        <FormControlLabel
         style={{paddingTop:theme.spacing(2)}}
         name='terms'
           control={<Checkbox onError={!checked} checked={checked} onChange={handleCheck} />}
           label={<Typography  variant='caption' color={'textSecondary'} >Ich habe die <a style={{color: theme.palette.text.secondary}} target="_blank" href='https://www.whataventure.com/data-protection-policy'>
            Datenschutzerklärung</a> gelesen und akzeptiere sie.</Typography>}
         />
         
         {error?
         <Box style={{paddingLeft:theme.spacing(4)}}>
       <Typography  variant='caption' color='error' align='center'  >
       Du musst den Bedingungen zustimmen, bevor du fortfahren kannst.
       </Typography>
       </Box>:null
       } */}
        <Button className={classes.button} type='submit' fullWidth color='secondary' variant='contained'>
                Senden</Button>
        <Box className={classes.box}>
        <Button onClick={()=>handleBack()} variant='text' className={classes.buttonSecondary}>Zurück</Button>
        </Box>
        </form>}
        </React.Fragment>

    )
}
